import { FleetVehicleFieldStatus } from './fleet-vehicle-field-status.enum';

export class FleetVehicleValidationMetadata {
	key: string;
	status: FleetVehicleFieldStatus;
	additionalData?: Record<string, string>;
}
